import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { CiImageOff } from "react-icons/ci";

import { getImageThumbnail, getVariantImage } from "../../../../utils/helpers";
import styles from "../../ProductCard.module.scss";

const ProductNutriScore = ({ product }) => (
  <div className={styles.nutriScore}>
    {product.nutri_score === "a" ? (
      <img className="mt-2 mb-3" src={"/prod/nutri_a.png"} alt="score_a" />
    ) : product.nutri_score === "b" ? (
      <img className="mt-2 mb-3" src={"/prod/nutri_b.png"} alt="score_b" />
    ) : product.nutri_score === "c" ? (
      <img className="mt-2 mb-3" src={"/prod/nutri_c.png"} alt="score_c" />
    ) : product.nutri_score === "d" ? (
      <img className="mt-2 mb-3" src={"/prod/nutri_d.png"} alt="score_d" />
    ) : null}
  </div>
);

const ProductStockTag = ({ product, selectedVariant }) => {
  if (selectedVariant.stock === 0) {
    return <Tag color="#ca2027">Out of Stock</Tag>;
  }
  if (selectedVariant.stock < product.low_stock) {
    return (
      <Tag style={{ color: "var(--color-dark)" }} color="#ffcf03">
        Limited Stock
      </Tag>
    );
  }
  return null;
};

const ProductImage = ({ product, selectedVariant }) => {
  const navigate = useNavigate();
  let image = getVariantImage(selectedVariant, product.variants);
  if (image === null) {
    return (
      <div className={styles.no_image}>
        <CiImageOff fontSize="5rem" />
        <span className={styles.no_image_text}>Image will be uploaded soon</span>
      </div>
    );
  }
  return (
    <img
      src={getImageThumbnail(image, 400)}
      alt={product.title || "product"}
      loading="lazy"
      decoding="async"
      onClick={() => {
        navigate(`/products/${product.slug}`);
      }}
      style={{
        ...(selectedVariant?.stock === 0 ? { filter: "grayscale(100%)" } : {}),
        cursor: "pointer",
      }}
    />
  );
};

export const ProductCardImagePanel = ({
  product,
  selectedVariant,
  productInWishlist,
  addToWishlist,
  removeFromWishlist,
}) => (
  <>
    <div className={styles.productCard_top}>
      <div className={styles.fav_wrapper} style={{ cursor: "pointer" }}>
        {productInWishlist ? (
          <img
            onClick={removeFromWishlist}
            src={"/icon/wishlist-added.svg"}
            alt="favorites"
          />
        ) : (
          <img
            onClick={addToWishlist}
            src={"/icon/wishlist.svg"}
            alt="favorites"
          />
        )}
      </div>
      <ProductNutriScore product={product} />
    </div>
    <div className={styles.productCard_img}>
      <ProductImage product={product} selectedVariant={selectedVariant} />
      <div className={styles.stock_tag_image}>
        <ProductStockTag product={product} selectedVariant={selectedVariant} />
      </div>
      <div className={styles.signs}>
        {selectedVariant?.discount_percentage > 0 && (
          <div className={styles.productCard_discount}>
            <span>{parseInt(selectedVariant.discount_percentage)}% OFF</span>
            <img src="/icon/product/discount.svg" alt="discount" />
          </div>
        )}
        {product.leaf_sign_2 && <img src="/icon/ps/bio.svg" alt="bio" />}
        {product.new_sign && <img src="/icon/ps/new.svg" alt="new" />}
        {product.leaf_sign_1 && <img src="/icon/ps/leaf.svg" alt="vegan" />}
      </div>
    </div>
  </>
);
